import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import * as Sentry from "@sentry/browser";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";
import { ensureFreshAppVersion, startAppVersionWatch } from "./data/appVersion";

const buildVersion = document
  .querySelector('meta[name="version"]')
  ?.getAttribute("content");

window.__EXCALIDRAW_SHA__ =
  import.meta.env.VITE_APP_GIT_SHA ||
  (buildVersion && buildVersion !== "{version}" ? buildVersion : undefined);

void ensureFreshAppVersion();
startAppVersionWatch();

const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW({
  immediate: true,
  onNeedRefresh: () => {
    console.info(
      "SW onNeedRefresh: update available. Reload manually to apply it.",
    );
    Sentry.captureMessage("PWA update available: waiting for manual reload", {
      level: "info",
    });
  },
});
root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
